<template>
  <div class="grid row schoolList">
    <div class="flex xs12 md12 container">
      <!-- <modals-container /> -->
      <va-card class="fill-height" style="background-color: #F2F6F6; color: #242A30; overflow-x: auto;"
        :title="'List of Entities'">
        <va-card-title class="group-title" style="color:#242A30; font-size:small; font-weight: 600;">List of
          Schools</va-card-title>
        <va-button class="alignright" color="gray" @click="createEntity">
          Create Entity
        </va-button>
        <va-modal v-model="showCreateEntityModal" overlay-opacity="0.2" size="medium" hide-default-actions blur>
          <template #header>
            <h2>New Entity</h2>
          </template>
          <CreateEntityModal @close="close" />
        </va-modal>
        <va-card-content>
          <div class="row align--center table-filters">
            <va-input class="flex mb-2 md6" placeholder="Search by school name..." v-model="filter" />
            <va-input class="flex mb-2 md3 offset--md3 white " type="number" placeholder="Entities..."
              label="Entities per page" v-model.number="perPage" />
          </div>
        </va-card-content>
        <hr />
        <va-card-content>
          <va-data-table animated=true no-data-html="No schools available" class="school-list" :items="filteredData"
            :columns="columns" :per-page="perPage" :current-page="currentPage" :filter="filter" :style="{
              '--va-data-table-background-color': '#F2F6F6',
              'color': '#242A30',
              'font-size': '14px',
              'font-family': 'Proxima',
              'font-weight': 'bold',
              '--va-data-table-thead-font-size': '.9rem'
            }" @filtered="filtered = $event.items">
            <template #cell(actions)="{ rowIndex }">
              <va-button size="small" color="gray" @click="selectEntity(rowIndex)">Select</va-button>
            </template>
            <template #bodyAppend>
              <tr>
                <td colspan="8" class="table-example--pagination">
                  <va-pagination v-model="currentPage" :visible-pages="4" :pages="pages ? pages : 5" />
                </td>
              </tr>
            </template>
          </va-data-table>
        </va-card-content>
      </va-card>
    </div>
  </div>
</template>

<script>


import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { defineComponent } from 'vue'
import CreateEntityModal from "@/modules/admin/components/CreateEntityModal"

export default defineComponent({
  components: {
    CreateEntityModal
  },
  data() {
    const users = [
      {
        industry_id: 1,
        entity_name: 'Leanne Graham',
        username: 'Bret',
        email: 'Sincere@april.biz',
        phone: '1-770-736-8031 x56442',
        website: 'hildegard.org'
      }
    ]

    const columns = [
      { key: 'industry_id', sortable: true, width: '15%' },
      { key: 'entity_name', sortable: true, width: '50%' },
      { key: 'industry_name', sortable: true, width: '30%' },
      { key: 'actions', dataClass: 'text-right' }
    ]
    const additionalStyle = {
      color: "white",
      fontWeight: 900
    };
    return {
      term: null,
      // items: this.entities,
      columns,
      perPage: 10,
      perPageOptions: ['4', '6', '10', '20'],
      currentPage: 1,
      filter: '',
      filtered: users,
      additionalStyle,
      showCreateEntityModal: false
    }
  },

  computed: {
    ...mapState({
      entities: state => state.user.entityLookUpList,
      canCreateEntity: state => state.user.isSuperUser
    }),
    pages() {
      return (this.perPage && this.perPage !== 0)
        ? Math.ceil(this.entities.length / this.perPage)
        : this.entities.length
    },
    filteredData() {
      if (!this.term || this.term.length < 1) {
        return this.entities
      }

      return this.entities.filter(item => {
        return item.entity_name
      })
    }
  },
  methods: {
    ...mapActions({
      getSchools: 'schools/getSchools',
      switchEntity: 'user/updateSelectedEntity'
    }),
    search: debounce(function (term) {
      this.term = term
    }, 400),
    selectEntity(id) {
      const selectedEntityId = id;
      this.selectedEntity = { ...this.entities[id] }
      this.switchEntity(this.selectedEntity)
      this.$router.push({ name: 'dashboard' })
    },
    close(){
      this.showCreateEntityModal = false
    },
    createEntity() {
      this.showCreateEntityModal = !this.showCreateEntityModal;
      // this.$modal.show(
      //   CreateEntityModal,
      //   { title: 'Create Entity' },
      //   { isAutoHeight: true, resizable: false, adaptive: true, draggable: true, root: this.$root }
      // )
    }
  }
})
</script>

<style lang="scss" scoped>
.school-list {

  .va-input__content-wrapper .va-input__content__input {
    color: #242A30 !important;
  }

  .table-filters {
    .white {
      color: #242A30
    }
  }

  .va-input__content {
    color: 242A30;
  }

  .va-data-table__table-th {
    color: white;
  }

  &.va-data-table .va-data-table__table .va-data-table__table-th {
    color: #000;
  }

  &.va-pagination__input {
    background: transparent
  }

  &.va-data-table--sticky {
    .va-data-table__table-th {
      color: white;
      background-color: #000;
    }
  }

  tr {
    color: '#242A30';

    td {
      height: 80px;
    }

    th {
      color: '#242A30'
    }
  }
}

.va-input__content__input {
  color: '#242A30'
}

.va-button__content {
  text-transform: none;
}

.table-example--pagination {
  text-align: center;
  text-align: -webkit-center;
}

.va-data-table .va-data-table__table .va-data-table__table-th .va-data-table__table-th-wrapper {
  color: '#242A30';
}

.va-input__content-wrapper .va-input__content__input {
  color: #242A30 !important;
}

.va-data-table {
  color: #242A30 !important;
}
</style>
